var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-table"},[_vm._t("after-table"),_vm._v(" "),_c('div',{ref:"table-sticky-trigger",staticClass:"m-table__sticky-trigger",style:(_vm.stickyTriggerStyle)}),_vm._v(" "),_c('table',{ref:"table-el",staticClass:"m-table__body",class:{
      'm-table_sticky': _vm.isSticky,
      'm-table_with-summary': _vm.withSummaryRow,
      'm-table_with-header-word-wrap': _vm.allowHeaderWordWrap
    },style:(_vm.cssVars)},[_c('thead',[_vm._t("table-header")],2),_vm._v(" "),_c('tbody',[_vm._t("table-content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }